import { render, staticRenderFns } from "./processManage.vue?vue&type=template&id=a60fbed8&scoped=true&"
import script from "./processManage.vue?vue&type=script&lang=js&"
export * from "./processManage.vue?vue&type=script&lang=js&"
import style0 from "./processManage.vue?vue&type=style&index=0&id=a60fbed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60fbed8",
  null
  
)

export default component.exports